import { FC } from 'react'
import { Form } from 'antd'
import { Rule } from 'antd/es/form'
import { NamePath } from 'antd/es/form/interface'
import PhoneControl from '../../custom-form-controls/phone-control/phone-control'
import _ from 'lodash'

interface PhoneProps {
  namePath?: NamePath
  rules?: Rule[]
  onChange?: (e: any) => void
  disabled?: boolean
  placeholder?: string
  label?: string
}

const Phone: FC<PhoneProps> = ({ namePath = [], rules, onChange, disabled, placeholder, label = 'Телефон' }) => {
  const name = _.concat(namePath, 'phone')

  return (
    <Form.Item name={name} label={label} rules={rules}>
      <PhoneControl onChange={onChange} disabled={disabled} placeholder={placeholder} />
    </Form.Item>
  )
}

export default Phone